import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Layout.css';

export default function Layout({ children, navItems, helpUrl }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const portalLabel = user?.role === 'parent'
    ? 'Parent Portal'
    : user?.role === 'instructor'
      ? 'Trainer Portal'
      : 'Admin Portal';

  const handleLogout = () => { logout().finally(() => navigate('/login')); };

  return (
    <div className={`layout layout--${user?.role || 'guest'} ${collapsed ? 'layout--collapsed' : ''}`}>
      <aside className="sidebar">
        <div className="sidebar-header">
          <img src="/wf-logo.png" alt="Wow Factor" className="sidebar-logo" />
          {!collapsed && (
            <div className="sidebar-brand">
              <span className="sidebar-brand-name">WOW FACTOR</span>
              <span className="sidebar-brand-sub">{portalLabel}</span>
            </div>
          )}
          <button className="sidebar-collapse-btn" onClick={() => setCollapsed(c => !c)}>
            {collapsed ? '→' : '←'}
          </button>
        </div>
        <nav className="sidebar-nav">
          {navItems.map(item => (
            <NavLink key={item.path} to={item.path} end={item.exact}
              className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}>
              <span className="sidebar-nav-icon" style={{ position:'relative' }}>
                {item.icon}
                {item.badge > 0 && (
                  <span className="nav-badge">{item.badge > 99 ? '99+' : item.badge}</span>
                )}
              </span>
              {!collapsed && <span className="sidebar-nav-label">{item.label}</span>}
              {!collapsed && item.badge > 0 && (
                <span className="nav-badge-label">{item.badge > 99 ? '99+' : item.badge}</span>
              )}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          {helpUrl && (
            <a href={helpUrl} target="_blank" rel="noopener noreferrer" className="sidebar-help-btn" title="How-To Guide">
              <span>📖</span>
              {!collapsed && <span>How-To Guide</span>}
            </a>
          )}
          <div className="sidebar-user">
            <div className="sidebar-user-avatar">{user?.first_name?.[0]}{user?.last_name?.[0]}</div>
            {!collapsed && (
              <div className="sidebar-user-info">
                <span className="sidebar-user-name">{user?.first_name} {user?.last_name}</span>
                <span className="sidebar-user-role">{user?.role}</span>
              </div>
            )}
          </div>
          <button className="sidebar-logout-btn" onClick={handleLogout} title="Logout">
            <span>⏻</span>
            {!collapsed && <span>Logout</span>}
          </button>
        </div>
      </aside>
      <main className="layout-main">
        <div className="portal-context-bar">
          <span className="portal-context-name"><i aria-hidden="true" />{portalLabel}</span>
          <span className="portal-context-tagline">Baseball Training &amp; Development</span>
        </div>
        {children}
      </main>
      <nav className="mobile-bottom-nav">
        <div className="mobile-bottom-nav-scroll">
          {navItems.map(item => (
            <NavLink key={item.path} to={item.path} end={item.exact}
              className={({ isActive }) => `mobile-tab ${isActive ? 'active' : ''}`}>
              <span className="mobile-tab-icon" style={{ position:'relative' }}>
                {item.icon}
                {item.badge > 0 && (
                  <span className="nav-badge">{item.badge > 99 ? '99+' : item.badge}</span>
                )}
              </span>
              <span className="mobile-tab-label">{item.label}</span>
            </NavLink>
          ))}
          {helpUrl && (
            <a href={helpUrl} target="_blank" rel="noopener noreferrer" className="mobile-tab">
              <span className="mobile-tab-icon">📖</span>
              <span className="mobile-tab-label">Guide</span>
            </a>
          )}
          <button className="mobile-tab mobile-tab-logout" onClick={handleLogout}>
            <span className="mobile-tab-icon">⏻</span>
            <span className="mobile-tab-label">Logout</span>
          </button>
        </div>
      </nav>
    </div>
  );
}
